import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { cn } from 'Utils/cn';

export default function RHFCellInput({ name, type = 'text', className, ...other }) {
    const { control, clearErrors } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => {
                useEffect(() => {
                    if (field.value && error) {
                        clearErrors(name);
                    }
                }, [name, field.value, clearErrors]);

                return (
                    <input
                        type={type}
                        className={cn(
                            'w-full px-3 bg-transparent border-0 focus:outline-none h-10',
                            'text-dark-blue placeholder:text-dark-blue/50 md:text-sm',
                            error && 'ring-1 ring-danger',
                            className,
                        )}
                        autoComplete="off"
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                            }
                        }}
                        {...field}
                        {...other}
                    />
                );
            }}
        />
    );
}

RHFCellInput.propTypes = {
    name: PropTypes.string,
    type: PropTypes.string,
    className: PropTypes.string,
};
